import styled from 'styled-components'

export default styled.div`
  bottom: 0;
  font-size: 10px;
  font-weight: 500;
  position: absolute;
  right: 0;
`
